import api from './api';

const webhookService = {
  getWebhooks: async (params = {}) => {
    const response = await api.get('/webhooks', { params });
    return response.data;
  },

  getWebhookById: async (id) => {
    const response = await api.get(`/webhooks/${id}`);
    return response.data;
  },

  createWebhook: async (data) => {
    const response = await api.post('/webhooks', data);
    return response.data;
  },

  updateWebhook: async (id, data) => {
    const response = await api.put(`/webhooks/${id}`, data);
    return response.data;
  },

  deleteWebhook: async (id) => {
    const response = await api.delete(`/webhooks/${id}`);
    return response.data;
  },

  regenerateSecret: async (id) => {
    const response = await api.post(`/webhooks/${id}/regenerate-secret`);
    return response.data;
  },

  getWebhookLogs: async (params = {}) => {
    const response = await api.get('/webhooks/logs', { params });
    return response.data;
  },

  resendWebhook: async (logId) => {
    const response = await api.post(`/webhooks/logs/${logId}/resend`);
    return response.data;
  }
};

export default webhookService;
